<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true" dataKey="name"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped">

  <!-- #endregion TABLE TITE DEFINITION -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

      <!-- DESCRIPTION -->
      <th pSortableColumn='description'>
        <div class='d-flex align-items-center h-100'>

          <!-- COLUMN TITLE -->
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'general.description' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='description'></p-sortIcon>
            <p-columnFilter field='description' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- VEHICLE -->
      <th pSortableColumn='vehicle.name'>
        <div class='d-flex align-items-center h-100'>

          <!-- COLUMN TITLE -->
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'tableManagement.notes.vehicle' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='vehicle.name'></p-sortIcon>
            <p-columnFilter field='vehicle' type='text' matchMode='contains'
              placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
          </div>

        </div>
      </th>

      <!-- NOTE DATE -->
      <th pSortableColumn='noteDate'>
        <div class='d-flex align-items-center h-100'>

          <!-- COLUMN TITLE -->
          <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
            {{ 'tableManagement.notes.dateNote' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class='d-flex align-items-center h-100'>
            <p-sortIcon field='noteDate'></p-sortIcon>
          </div>

        </div>
      </th>

      <!-- DELETE -->
      <th class="button-column"></th>



    </tr>
  </ng-template>
  <!-- #endregion TABLE COLUMN DEFINITION -->

  <!-- #region TABLE BODY -->
  <ng-template pTemplate="body" let-entity>
    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(entity)">

      <!-- NAME -->
      <td>
        {{ entity.description }}
      </td>

      <td>
        {{ entity.vehicle?.name }}
      </td>

      <td>
        {{ entity.noteDate | date: 'dd/MM/yyyy' }}
      </td>

      <!-- DELETE -->
      <td>
        @if (isDeleteGranted) {
          <div>
            <button  type="button" class="btn custom-table-remove-button" (click)="onDeleteNote(entity)">
              <svg-icon
                src="assets/icons/trash.svg"
                class="d-flex flex-wrap custom-table-remove-button-icon"
                [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
              ></svg-icon>
            </button>
          </div>
        }

      </td>

    </tr>

  </ng-template>
  <!-- #endregion TABLE BODY -->

  <!-- #region TABLE EMPTY MESSAGE -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4" class="p-0">
        <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE EMPTY MESSAGE -->

  <!-- #region TABLE FOOTER -->
  <ng-template pTemplate="footer">
    <tr>
      <td colspan="4" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">

          <!-- ADD accessory BUTTON -->
          @if (isCreateGranted) {
            <app-table-add-button [text]=" 'tableManagement.notes.notes' | translate"
            (btnClick)="create()"></app-table-add-button>
          }


        </div>
      </td>
    </tr>
  </ng-template>
  <!-- #endregion TABLE FOOTER -->
</p-table>


<!-- RENTING TYPE FORM -->
<app-notes-form [vehicle]="vehicle" (return)="refreshList($event,false)"></app-notes-form>

<p-confirmDialog
  #saveEventDialog
  [header]="'confirm.critic' | translate"
  [message]="'control-panel.delete-dialog.message' | translate"
  class="custom-dialog"
  icon="pi pi-exclamation-triangle"
  key="notes-list"
  >
  <ng-template pTemplate="footer">
    <!-- REJECT BUTTON -->
    <button (click)="saveEventDialog.onReject()" class="custom-button">
      {{ 'general.no' | translate }}
    </button>
    <!-- ACCEPT BUTTON -->
    <button (click)="saveEventDialog.onAccept()" class="custom-button">
      {{ 'general.yes' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>